const ICONS = Object.freeze({
  gym: '🏋️', office: '💼', work: '💼', casual: '👕', date: '🌹', evening: '🌙',
  'night out': '🌙', errands: '🛍️', wedding: '💍', 'sporting event': '🏟️',
  concert: '🎵', travel: '✈️', vacation: '🏖️', 'formal event': '🎩', event: '🎩',
  home: '🏠', dinner: '🍽️', outdoors: '🌳', birthday: '🎂', anniversary: '💞',
})
export function contextEmoji(tag) {
  return ICONS[String(tag || '').trim().toLowerCase().replaceAll('_', ' ')] || ''
}
